import React from 'react'
import { Icon, Grid, Button, Form, List, Image, Checkbox, Message } from 'semantic-ui-react'
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';

import PracticeRejectionNotesModal from '../modals/PracticeRejectionNotesModal'
import { Maybe } from 'flowr';
import { toastr } from 'react-redux-toastr';
import isEqual from 'lodash/isEqual'
import Labels from './../../../../common/Labels'
import Define from "./../../../../../images/svg/arrangementPane/icon-define.svg";
import Configure from "./../../../../../images/svg/arrangementPane/icon-configure.svg";
import Sequence from "./../../../../../images/svg/arrangementPane/icon-sequence.svg";
import { withRouter } from 'react-router-dom';
import CircularDependencies from '../../../../common/CircularDependencies';
import LoadingComponent from '../../../../common/LoadingComponent';
import MomentDate from '../../../../common/MomentDate';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import noImage from './../../../../../images/common/broken-image.png'
import { isBlockedBySubscriptionLimit } from '../../../../../helpers/subscriptionLimitCheck';
const Graph = require('graph.js/dist/graph.full.js');
let reviewers = [];

@source({
    mouseEnter: () => {
        dispatch.app.setHelpContext("Publish")
    }
})
class PublishPack extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            errors2: [],
            openModal: false,
            openNotesModal: false,
            currentReview: {},
            isAuthorizedToPublish: false,
            isReviewPending: false,
            loader: true,
            createInitiativeSelectedTeam: "",
            // createInitiative: true
        };
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.handleTeamSelection = this.handleTeamSelection.bind(this);
    }

    async redirectTo(index) {
        let pathname = ""
        const { history } = this.props;
        dispatch.lifeCycle.setArrangementPaneActiveButtonFlag(index)
        switch (index) {
            case 0:
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/playbookLibrary`;
                dispatch.lifeCycle.setArrangementPaneFlag(true);
                await dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
                await dispatch.lifeCycle.showResourecePane("Indesign");
                break;
            case 1:
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/configure`;
                break;
            case 2:
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/sequence`;
                break;
        }
        history.push({ pathname: pathname });
    }


    async componentDidMount() {
        this.setState({ loader: true });
        await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);


        let graph = new Graph();
        await this.generateGraph(graph);
        this.props.selectedPracticeLibrary.cycles = [];
        if (graph.cycle() && graph.cycle().length > 0) {

            for (let cycle of graph.cycles()) {
                this.props.selectedPracticeLibrary.cycles.push(cycle);
            }
        }
        this.checkContent();
    }

    generateGraph = async (graph) => {
        this.createGraph(this.props.selectedPracticeLibrary.activities, null, graph)
    }
    createGraph = function (activities, parent, graph, isSequential) {
        try {
            if (activities && activities.length > 0) {

                for (const [index, activity] of activities.entries()) {

                    const graphObject = {
                        name: activity.name,
                    }
                    graph.addVertex(activity._id.toString(), graphObject);

                    if (parent) {
                        graph.addEdge(parent._id.toString(), activity._id.toString());
                    }
                    if (activity.dependencies && activity.dependencies.length > 0) {
                        for (const dependency of activity.dependencies) {
                            if (!graph.hasVertex(dependency.toString())) {

                                graph.ensureVertex(dependency.toString(), { details: "temp ref" });
                            }


                            graph.addEdge(activity._id.toString(), dependency.toString())
                        }
                    }
                    this.createGraph(activity.activities, activity, graph);
                }
            }
        }
        catch (e) {
            console.error('Error while cerating the initiative graph ', e);
        }
    }

    async componentWillMount() {        
        let payload = {
            _id: this.props.selectedOrganisation.id
        };
        await dispatch.organizationUnit.getOrganizationTeams(payload);
    }

    async componentWillReceiveProps(nextProps) {

        let objValidation = Object.entries(this.props.selectedPracticeLibrary).length === 0 && this.props.selectedPracticeLibrary.constructor === Object
        if (!objValidation) {
            if (nextProps.selectedPracticeLibrary && !isEqual(this.props.selectedPracticeLibrary, nextProps.selectedPracticeLibrary)) {
                let graph = new Graph();
                await this.generateGraph(graph);
                this.props.selectedPracticeLibrary.cycles = [];
                if (graph.cycle() && graph.cycle().length > 0) {

                    for (let cycle of graph.cycles()) {
                        this.props.selectedPracticeLibrary.cycles.push(cycle);
                    }
                }
                this.checkContent();
            }
            this.checkIfReviewPending();
            this.checkIfAuthorizedToPublish();
            this.checkIfAuthorizedToPublish();
            this.checkIfReviewPending();
        }
        if(nextProps.selectedPracticeLibrary){
            if(nextProps.selectedPracticeLibrary.createInitiative){
                // this.setState({"createInitiative": nextProps.selectedPracticeLibrary.createInitiative});  //KLM-9248
            }
            if(nextProps.selectedPracticeLibrary.createInitiativeTeams && nextProps.selectedPracticeLibrary.createInitiativeTeams.length>0){
                this.setState({"createInitiativeSelectedTeam": nextProps.selectedPracticeLibrary.createInitiativeTeams[0]});
            }
        }
        // if(nextProps.publishingPracticeLoader && !this.state.loader){
        //     this.state.loader(true);
        // }
    }

    publishPractice = () => {
        const { accountSubscriptionDetail } = this.props
        let defaults = accountSubscriptionDetail.consumptionDefaults || {};
        let requiredCredits = defaults.playbookPublished;
        if (isBlockedBySubscriptionLimit({
            accountSubscriptionDetail,
            selectedAccount: this.props.selectedAccount,
            user: this.props.user,
            requiredCredits,
            entity: "Playbooks",
            entityType: "Publish Playbook",
        })) {
            // blocked, modal shown by helper
        } else {
            let message = <div className="confirmMessage">
                <h3>Publish Playbook</h3>
                <label>{this.props.selectedPracticeLibrary.name}</label>
                <p>Are you sure that you wish to do this?</p>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    this.setState({loader:true});
                    let data = {
                        createInitiative: this.props.selectedPracticeLibrary.createInitiative,
                        
                    }
                    if(this.state.createInitiativeSelectedTeam == 'Select'){
                        data.createInitiativeTeams = []
                    } else {
                        data.createInitiativeTeams = [this.state.createInitiativeSelectedTeam]
                    }
                    let payload = {
                        _id: this.props.selectedPracticeLibrary._id,
                        data: data
                    }
                    // this.setState({ createInitiative:this.state.createInitiative });
                    await dispatch.lifeCycle.publishPractice(this.props.selectedPracticeLibrary);
                    this.props.history.push(`/app/${this.props.selectedPracticeLibrary.accountId}/_ws/${this.props.selectedPracticeLibrary.organizationId}/_pb/status/Published`)
                    dispatch.lifeCycle.updatePlaybook(payload);
                }
            });
        }
    }
    checkIfPrivateContentsAdded = (activity, activityName, errors, errors2) => {
        if (this.props.selectedPracticeLibrary.scope === "Public") {
            for (const input of activity.inputs) {


                if (input.scope === "Private") {
                    errors.push(`Activity ${activityName} can not have private input content`);
                    errors2.push({
                        type: "sequence",
                        phase: activityName,
                        description: "You must use references from Public Library"
                    });
                    break;
                }
            }
            for (const output of activity.outputs) {
                if (output.scope === "Private") {
                    errors.push(`Activity ${activityName} can not have private output content`);
                    errors2.push({
                        type: "sequence",
                        phase: activityName,
                        description: "You must use references from Public Library"
                    });
                    break;
                }
            }
            for (const reference of activity.references) {
                if (reference.id.scope === "Private") {
                    errors.push(`Activity ${activityName} can not have private reference content`);
                    errors2.push({
                        type: "sequence",
                        phase: activityName,
                        description: "You must use references from Public Library"
                    });
                    break;
                }
            }
        }

    }
    checkContent = () => {
        this.setState({ loader: true });
        let errors = []
        let errors2 = []
        if (this.props.selectedPracticeLibrary.tags && this.props.selectedPracticeLibrary.tags.length === 0) {
            errors.push("At least one tag should be there");
            errors2.push({
                type: "define",
                name: "Tags",
                description: "Playbook must have at least one tag."
            });
        }
        if (!this.props.selectedPracticeLibrary.baseCategory || !this.props.selectedPracticeLibrary.category || !this.props.selectedPracticeLibrary.subCategory) {
            errors.push("Please select Publish Category");
            errors2.push({
                type: "define",
                name: "Publishing / Category",
                description: "Please select Publish Category"
            });
        }
        if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.activities) {
            for (const phase of this.props.selectedPracticeLibrary.activities) {
                this.checkIfPrivateContentsAdded(phase, phase.name, errors, errors2);

                if (!phase.raci) {
                    errors.push(`Activity ${phase.name} must have Accountable & Responsible mapping`);
                    errors2.push({
                        type: "configure",
                        phase: phase.name,
                        description: "Must have at least one Accountable & Responsible mapping"
                    });
                }
                else {
                    if (!phase.raci.a) {
                        errors.push(`Activity ${phase.name} must have Accountable mapping`);
                        errors2.push({
                            type: "configure",
                            phase: phase.name,
                            description: "Must have at least one Accountable mapping"
                        });
                    }
                    if (!phase.raci.r || phase.raci.r.length === 0) {
                        errors.push(`Activity ${phase.name} must have Responsible mapping`);
                        errors2.push({
                            type: "configure",
                            phase: phase.name,
                            description: "Must have at least one Responsible mapping"
                        });
                    }
                }
                if (phase.activities) {
                    if (phase.activities.length === 0) {
                        errors.push(`Activity ${phase.name} should contain at least one leaf Activity`);
                        errors2.push({
                            type: "sequence",
                            phase: phase.name,
                            description: "Must have at least one leaf Activity"
                        });
                    }

                    for (const stage of phase.activities) {
                        this.checkIfPrivateContentsAdded(stage, `${phase.name} > ${stage.name}`, errors, errors2);

                        if (!stage.raci) {
                            errors.push(`Activity ${phase.name} > ${stage.name} must have Accountable & Responsible mapping`);
                            errors2.push({
                                type: "configure",
                                phase: phase.name,
                                stage: stage.name,
                                description: "Must have at least one Accountable & Responsible mapping"
                            });
                        }
                        else {
                            if (!stage.raci.a) {
                                errors.push(`Activity ${phase.name} > ${stage.name} must have Accountable mapping`);
                                errors2.push({
                                    type: "configure",
                                    phase: phase.name,
                                    stage: stage.name,
                                    description: "Must have at least one Accountable"
                                });
                            }
                            if (!stage.raci.r || stage.raci.r.length === 0) {
                                errors.push(`Activity ${phase.name} > ${stage.name} must have Responsible mapping`);
                                errors2.push({
                                    type: "sequence",
                                    phase: phase.name,
                                    stage: stage.name,
                                    description: "Must have at least one Responsible"
                                });
                            }
                        }
                        if(stage.isSmartActivity && stage.isLeafNode) {
                            if(!stage.activityActions){
                                errors.push(`Activity ${phase.name} > ${stage.name} must have event set at processing tab`);
                                errors2.push({
                                    type: "sequence",
                                    phase: phase.name,
                                    stage: stage.name,
                                    description: "Must have event set at processing tab"
                                });
                            }
                        }
                        if (stage.activities) {
                            if (stage.isParentNode && stage.activities.length === 0 && !stage.integration) {
                                errors.push(`Activity ${phase.name} > ${stage.name} should contain at least one leaf Activity`);
                                errors2.push({
                                    type: "sequence",
                                    phase: phase.name,
                                    stage: stage.name,
                                    description: "Must have at least one leaf activity"
                                });
                            }
                            for (const activity of stage.activities) {
                                if (activity) {
                                    this.checkIfPrivateContentsAdded(activity, `${phase.name} > ${stage.name} > ${activity.name}`, errors, errors2);
                                    if (!activity.raci) {
                                        errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Accountable & Responsible mapping`);
                                        errors2.push({
                                            type: "sequence",
                                            phase: phase.name,
                                            stage: stage.name,
                                            activity: activity.name,
                                            description: "Must have at least one Accountable & Responsible"
                                        });
                                    }
                                    else {
                                        if (!activity.raci.a) {
                                            errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Accountable mapping`);
                                            errors2.push({
                                                type: "sequence",
                                                phase: phase.name,
                                                stage: stage.name,
                                                activity: activity.name,
                                                description: "Must have at least one Accountable"
                                            });
                                        }
                                        if (!activity.raci.r || activity.raci.r.length === 0) {
                                            errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Responsible mapping`);
                                            errors2.push({
                                                type: "sequence",
                                                phase: phase.name,
                                                stage: stage.name,
                                                activity: activity.name,
                                                description: "Must have at least one Responsible"
                                            });
                                        }

                                    }
                                    if(activity.isSmartActivity && activity.isLeafNode){
                                        if(!activity.activityActions){
                                            errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have event set at processing tab`);
                                            errors2.push({
                                                type: "sequence",
                                                phase: phase.name,
                                                stage: stage.name,
                                                activity: activity.name,
                                                description: "Must have event set at processing tab"
                                            });
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            errors.push(`Activity ${phase.name} > ${stage.name} should contain at least one leaf Activity`);
                            errors2.push({
                                type: "sequence",
                                phase: phase.name,
                                stage: stage.name,
                                description: "Must have at least one leaf Activity"
                            });
                        }

                    }
                }
                else {
                    errors.push(`Activity ${phase.name} should contain at least one leaf Activity`);
                    errors2.push({
                        type: "sequence",
                        phase: phase.name,
                        description: "Must have at least one leaf Activity"
                    });
                }

            }
        }
        if (this.props.selectedPracticeLibrary.cycles && this.props.selectedPracticeLibrary.cycles.length > 0) {
            errors.push(`${this.props.selectedPracticeLibrary.cycles.length} circular dependencies are found`);
            errors2.push({
                type: "circular",
                cycles: this.props.selectedPracticeLibrary.cycles,
                description: "circular dependencies are found"
            });
        }

        this.setState({ errors: errors, errors2: errors2 })
        if(this.props.selectedPracticeLibrary.status !== 4){
            this.setState({loader: false})
        }
    }

    closeModal = () => {
        this.setState({ openModal: false });
    }
    closeNotesModal = () => {
        this.setState({ openNotesModal: false });
    }
    updatePractice = () => {
        const { history } = this.props;

        this.setState({ openModal: false })
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/inReview`);
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 0, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
        dispatch.lifeCycle.getCounts({ id: this.props.selectedOrganisation.id })

    }
    addToReview = (reviewers, e) => {
        const { history } = this.props;
        let message = <div className="confirmMessage">
            <h3>Request Review</h3>
            <p>Are you sure that you wish to request review?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.lifeCycle.addPracticeToReview({ id: this.props.selectedPracticeLibrary._id, reviewers: reviewers, organizationId: this.props.selectedOrganisation.id });
                history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/inReview`);
                dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 1, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
                dispatch.lifeCycle.getCounts({ id: this.props.selectedOrganisation.id })
            }
        });

    }
    requestReview = () => {
        this.setState({ openModal: true });

    }
    rejectClick = () => {
        this.setState({ openNotesModal: true })
    }
    checkIfReviewPending() {
        if (this.props.selectedPracticeLibrary.reviewStatus && this.props.selectedPracticeLibrary.reviewStatus.length > 0) {
            this.props.selectedPracticeLibrary.reviewStatus.map(review => {
                if (this.props.user._id === review.accountUserId) {
                    this.setState({ currentReview: review });
                    if (review.status === 0)
                        this.setState({ isReviewPending: true });
                    return;
                }

            });
        }
    }
    approve = () => {

        let message = <div className="confirmMessage">
            <h3>Approve Playbook</h3>
            <label>{this.props.selectedPracticeLibrary.name} {this.props.practiceLabelName}</label>
            <p>Are you sure that you wish to approve?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                const { history } = this.props;
                this.props.selectedPracticeLibrary.reviewStatus.map(review => {
                    if (this.props.user._id === review.accountUserId) {
                        this.setState({ currentReview: review });
                        review.status = 1;
                    }
                });
                dispatch.lifeCycle.approvePractice({ id: this.props.selectedPracticeLibrary._id, reviewers: this.props.selectedPracticeLibrary.reviewStatus, organizationId: this.props.selectedOrganisation.id });
                // dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 2, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
                history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/Approved`);
            }
        });

    }
    publishPracticeSelf = () => {
        const { accountSubscriptionDetail } = this.props
        let defaults = accountSubscriptionDetail.consumptionDefaults || {};
        let requiredCredits = defaults.playbookPublished;
        if (isBlockedBySubscriptionLimit({
            accountSubscriptionDetail,
            selectedAccount: this.props.selectedAccount,
            user: this.props.user,
            requiredCredits,
            entity: "Playbooks",
            entityType: "Publish Playbook",
        })) {
            // blocked, modal shown by helper
        } else {
            let message = <div className="confirmMessage">
                <h3>Publish Playbook</h3>
                <label>{this.props.practiceLabelName}</label>
                <p>Are you sure that you wish to publish this Playbook without Review?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: () => {
                    dispatch.lifeCycle.publishPractice(this.props.selectedPracticeLibrary);
                    this.props.history.push(`/app/${this.props.selectedPracticeLibrary.accountId}/_ws/${this.props.selectedPracticeLibrary.organizationId}/_pb/status/Published`)
                    dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 4, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
                    dispatch.lifeCycle.getCounts({ id: this.props.selectedOrganisation.id })
                }
            });
        }
    }
    reject = () => {
        const { history } = this.props;
        let message = <div className="confirmMessage">
            <h3>Reject Request</h3>
            <p>Are you sure that you wish to reject this request?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                this.props.selectedPracticeLibrary.reviewStatus.map(review => {
                    if (this.props.user._id === review.accountUserId) {
                        this.setState({ currentReview: review });
                        review.status = 2;
                        review.date = new Date();
                    }
                });
                dispatch.lifeCycle.rejectPractice({ id: this.props.selectedPracticeLibrary._id, reviewers: this.props.selectedPracticeLibrary.reviewStatus, organizationId: this.props.selectedOrganisation.id });
                history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/inReview`);
                dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 3, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
                this.movePracticeToIndesign();
                dispatch.lifeCycle.getCounts({ id: this.props.selectedOrganisation.id })
            }
        });

    }
    checkIfAuthorizedToPublish() {
        if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.scope === 'Public') {
            if (this.props.selectedOrganisation.role === 'workspaceOwner') {
                this.setState({ isAuthorizedToPublish: true });
            }
        }
        else {
            this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.map(participant => {

                if (this.props.user._id === participant.accountUserId && participant.role === 'author') {
                    this.setState({ isAuthorizedToPublish: true });
                }
            });
        }


    }
    addNote = (note) => {
        this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.reviewStatus && this.props.selectedPracticeLibrary.reviewStatus.map((review, i) => {

            if (this.props.user._id === review.accountUserId) {

                review.note = note;
                this.setState({ currentReview: review })
            }
        });

    }
    movePracticeToIndesign() {
        const { history } = this.props;
        if (!this.props.selectedPracticeLibrary.reviewHistory)
            this.props.selectedPracticeLibrary.reviewHistory = [];
        dispatch.lifeCycle.movePracticeToIndesign({ selectedPracticeLibrary: this.props.selectedPracticeLibrary, organizationId: this.props.selectedOrganisation.id });
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/inReview`);
        dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: 0, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
    }

    gotToUpgradePage = () => {

        const history = this.props.history;

        history.push({
            pathname: `/app/${this.props.selectedAccount._id}/upgrade`
        });
    }

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    handleCheckbox(event, data) {
        if('checked' in data){
            // this.setState({ createInitiative: data.checked }, () => {});
            let payload={
             "_id":this.props.selectedPracticeLibrary._id
            }
              payload.data={
                "createInitiative":data.checked
              }
            // payload.createInitiative=data.checked
            dispatch.lifeCycle.updatePlaybook(payload)
        }
    }
    handleTeamSelection(data) {
        this.setState({"createInitiativeSelectedTeam": data.target.value})
    }
    render() {
        let description = this.props.selectedPracticeLibrary.description === "" ||
            this.props.selectedPracticeLibrary.description === null ?
            "No Description Added" : this.props.selectedPracticeLibrary.description;
        let summarySection = () => {
            return <div className="w_100 pad_0 summary_section overflow-auto" style={{ maxHeight: this.props.componentDesignerDimension.windowHeight - 260 }}>
                <Grid className="rowStyle row_pad_0 " onMouseEnter={() => dispatch.app.setHelpContext("Playbook Summary")}>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Grid className="summary_section_block" >
                                <Grid.Row >
                                    <Grid.Column width={16}>
                                        <strong> Playbook Summary</strong>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row >
                                    <Grid.Column width={12}>
                                        <Labels
                                            name="Name"
                                            text={this.props.selectedPracticeLibrary.name} />
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        <Labels
                                            name="Pubilsh Level"
                                            text={this.props.selectedPracticeLibrary.scope === "Private" ? "Workspace Library" : "Public Library"} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row >
                                    <Grid.Column width={12}>
                                        <Labels
                                            name="Playbook Category"
                                            text={<span>
                                                {this.props.selectedPracticeLibrary.baseCategory && this.props.selectedPracticeLibrary.baseCategory.name}
                                                <Icon name="angle right" />
                                                {this.props.selectedPracticeLibrary.category && this.props.selectedPracticeLibrary.category.name}
                                                <Icon name="angle right" />
                                                {this.props.selectedPracticeLibrary.subCategory && this.props.selectedPracticeLibrary.subCategory.name}
                                            </span>} />
                                    </Grid.Column>
                                    <Grid.Column width={4}>
                                        <Labels
                                            name="Version"
                                            text={this.props.selectedPracticeLibrary.version} />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Image onError={this.addDefaultSrc} src={this.props.selectedPracticeLibrary.picture} className="fitImage" />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row >
                        <Grid.Column width={16}>
                            <Labels
                                name="Description"
                                text={description}
                                htmlView={true} />
                        </Grid.Column>
                    </Grid.Row>
                    {this.props.selectedPracticeLibrary.prerequisite ?
                        <Grid.Row >
                            <Grid.Column width={16}>
                                <Labels
                                    name="Prerequisite"
                                    text={this.props.selectedPracticeLibrary.prerequisite}
                                    htmlView={true} />
                            </Grid.Column>
                        </Grid.Row> : ""}
                    <Grid.Row>
                    <div style={{paddingLeft:"12px",marginRight:this.props.selectedPracticeLibrary.createInitiative?"13px":"10px"}}>
                        {this.props.selectedPracticeLibrary.createInitiative?
                            <Labels name={"Create Initiative Enabled"} />:
                            <Labels name={"Create Initiative Disabled"} />
                        }
                    </div>
                    <Grid.Column width={12}>
                        <Checkbox 
                            key={this.props.selectedPracticeLibrary.createInitiative} 
                            onChange={(event, data) => this.handleCheckbox(event, data)}
                            toggle={true}
                            checked={this.props.selectedPracticeLibrary.createInitiative}
                            disabled={false}
                            slider={true}
                        />
                    </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                    <Grid.Column style={{ 'margin-top': '8px' }} width={3}>
                        <Labels name="Create Initiative Team" />
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Form.Group grouped>
                            <Form.Field
                                id='createInitiativeTeam' control='select'
                                value={this.state.createInitiativeSelectedTeam}
                                onChange={this.handleTeamSelection}
                                className="formcyFormErrorMsg">
                                <option value="Select">Select</option>
                                {this.props.orgTeams.subOrganizations && this.props.orgTeams.subOrganizations.map((team, index) => {
                                    return (
                                        <option key={index} value={team._id} >{team.name}</option>
                                    );
                                }, this)}

                            </Form.Field>
                            <span className="clr-red">
                                Selected Team will be able to create initiatives even if 'Create Initiative' is turned off.
                            </span>
                        </Form.Group>
                    </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        }

        let tags = this.state.errors2.filter((item) => (item.type === "define"))
        let configure = this.state.errors2.filter((item) => (item.type === "configure"))
        let sequence = this.state.errors2.filter((item) => (item.type === "sequence"))
        let circular = this.state.errors2.filter((item) => (item.type === "circular"))
        let requestReview = () => {
            if (this.props.selectedPracticeLibrary.status === 0 || this.props.selectedPracticeLibrary.status === 2) {
                if (this.state.errors.length === 0) {
                    return (
                        <Form name="reviewForm" onSubmit={(data) => { this.requestReview(data) }} className="formcyForm" style={{ "width": "100%" }}>
                            <Maybe when={this.state.errors.length === 0}>
                                <Grid >
                                    {this.props.selectedPracticeLibrary.reviewHistory && this.props.selectedPracticeLibrary.reviewHistory.map((review, i) => {
                                        if (review.status !== 0)
                                            return (<Grid.Row key={i} className="rowStyle" style={{ borderBottom: "1px solid #EEF1F3" }}>
                                                <Grid.Column width={11}>
                                                    <Icon
                                                        style={{ fontSize: "8px", margin: "0 5px 0 0" }}
                                                        circular
                                                        className={review.status === 2 ? "bg-orange" : "bg-green"}
                                                        name={review.status === 2 ? "close" : "checkmark"}
                                                    />
                                                    <span className={review.status === 2 ? "clr-orange" : "clr-green"} >
                                                        {review.status === 2 ? "Rejected" : "Approved"}
                                                    </span>
                                                    &nbsp;&nbsp;&nbsp;
                                                    on <strong> <MomentDate date={review.date} /> </strong>
                                                    &nbsp;&nbsp;&nbsp;
                                                    by <strong>{review.name}</strong>
                                                </Grid.Column>
                                                <Grid.Column width={5} style={{ "word-break": "break-all" }}>
                                                    {/* {review.note} */}
                                                    <div dangerouslySetInnerHTML={{ __html: review.note }} />
                                                </Grid.Column>
                                            </Grid.Row>)
                                    })}

                                    {this.props.selectedPracticeLibrary.status === 0 && <div className="w_100 rowStyle">
                                        <Maybe when={reviewer() !== ''}>
                                            <Grid.Row style={{ padding: "10px 0" }}>
                                                <Grid.Column width={16} floated='left' >
                                                    <div className='well'>Reviewers</div>
                                                    <br />
                                                    <strong>
                                                        <List size="small" className="reviewList" verticalAlign='middle'>
                                                            {reviewers.map((reviewer, index) => {
                                                                return (
                                                                    <List.Item key={index}>
                                                                        <ImageAvater user={reviewer} profilePic={reviewer.profilePic} />
                                                                        <List.Content className="float-left" style={{ 'margin-top': '5px' }}>
                                                                            <List.Header>{reviewer.name}</List.Header>
                                                                        </List.Content>
                                                                    </List.Item>
                                                                );
                                                            })}
                                                        </List>

                                                    </strong>

                                                    <Maybe when={this.state.isAuthorizedToPublish}>
                                                        <Button className="button-info pull-right" id='addbtn' type="submit" onClick={(e) => this.addToReview(reviewers, e)}> Request Review</Button>
                                                    </Maybe>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Maybe>
                                    </div>
                                    }
                                    {summarySection()}
                                </Grid >
                            </Maybe>

                        </Form>
                    )
                }
                else {
                    return (
                        <Grid >
                            {this.props.selectedPracticeLibrary.reviewHistory && this.props.selectedPracticeLibrary.reviewHistory.map((review, i) => {
                                if (review.status !== 0)
                                    return (<Grid.Row className="rowStyle" key={i}>
                                        <Grid.Column width={1}>
                                            <strong>
                                                {review.status === 2 && <Icon className='clr-orange' name='close' />}
                                                {review.status === 1 && <Icon className='clr-green' name='checkmark' />}
                                            </strong>
                                        </Grid.Column>
                                        <Grid.Column width={2}>
                                            <strong>
                                                {review.status === 2 && <div>Rejected</div>}
                                                {review.status === 1 && <div>Approved</div>}
                                            </strong>
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            <strong>{review.name}</strong>
                                        </Grid.Column>
                                        <Grid.Column width={3}>
                                            on <strong> <MomentDate date={review.date} /> </strong>
                                        </Grid.Column>
                                        <Grid.Column width={7} style={{ "word-break": "break-all" }}>
                                            {review.note}
                                        </Grid.Column>

                                    </Grid.Row>)
                            })}
                            <Grid.Row className="rowStyle ">
                                <Grid.Column width={16} className="pad_10">
                                    Please resolve following issues in {this.props.practiceLabelName} to proceed further,
                                </Grid.Column>
                            </Grid.Row>

                            <div style={{ height: this.props.componentDesignerDimension.windowHeight - 200, overflow: "auto", padding: 0, width: "100%" }} onMouseEnter={() => dispatch.app.setHelpContext("Validation List Pane")}>
                                {tags.length > 0 ? <Grid.Row className="rowStyle error_block">

                                    <div className="error_head" >
                                        <img src={Define} alt="Define" /> <span>Define</span>
                                    </div>
                                    {tags.map((error, i) => {
                                        return (
                                            <div key={i} className="error_body" onClick={() => this.redirectTo(0)}>
                                                <div className="error_icon">
                                                    <Icon circular name="exclamation" />
                                                </div>
                                                <div className="error_desc">
                                                    <strong>{error.name}</strong> <br />
                                                    <span>{error.description}</span>
                                                </div>
                                                <div className="error_arrow">
                                                    <Icon name="chevron right" />
                                                </div>
                                            </div>
                                        );
                                    })}

                                </Grid.Row> : ""}

                                {configure.length > 0 ? <Grid.Row className="rowStyle error_block">

                                    <div className="error_head" >
                                        <img src={Configure} alt="configure" /> <span>Configure</span>
                                    </div>
                                    {configure.map((error, i) => {
                                        return (
                                            <div key={i} className="error_body" onClick={() => this.redirectTo(1)} >
                                                <div className="error_icon">
                                                    <Icon circular name="exclamation" />
                                                </div>
                                                <div className="error_desc">
                                                    <strong>{error.phase} {error.stage ? <Icon name="angle right" /> : ""} {error.stage ? error.stage : ""} </strong> <br />
                                                    <span>{error.description}</span>
                                                </div>
                                                <div className="error_arrow">
                                                    <Icon name="chevron right" />
                                                </div>
                                            </div>
                                        );
                                    })}

                                </Grid.Row> : ""}
                                {sequence.length > 0 || circular.length > 0 ? <Grid.Row className="rowStyle error_block">

                                    <div className="error_head" >
                                        <img src={Sequence} alt="Sequence" /> <span>Sequence</span>
                                    </div>
                                    {sequence.map((error, i) => {
                                        return (
                                            <div key={i} className="error_body" onClick={() => this.redirectTo(2)}>
                                                <div className="error_icon">
                                                    <Icon circular name="exclamation" />
                                                </div>
                                                <div className="error_desc">
                                                    <strong>{error.phase} {error.stage ? <Icon name="angle right" /> : ""}{error.stage ? error.stage : ""} {error.activity ? <Icon name="angle right" /> : ""} {error.activity ? error.activity : ""} </strong> <br />
                                                    <span>{error.description}</span>
                                                </div>
                                                <div className="error_arrow">
                                                    <Icon name="chevron right" />
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {circular.length > 0 && <div className="error_body">
                                        <div className="error_icon">
                                            <Icon circular name="exclamation" />
                                        </div>
                                        <div className="error_desc">
                                            <CircularDependencies selectedEntity={this.props.selectedPracticeLibrary} showActions={true} fixAction={dispatch.lifeCycle.removeAllDependenciesFromPlaybook} manualAction={() => this.redirectTo(2)} />
                                        </div>
                                    </div>}

                                </Grid.Row> : ""}
                            </div>

                        </Grid>
                    );
                }
            }
        }
        const reviewer = () => {
            reviewers = [];
            for (const participant of this.props.selectedPracticeLibrary.participants) {

                if (participant.role === 'reviewer') {
                    reviewers.push({
                        accountUserId: participant.accountUserId,
                        name: participant.name, status: 0,
                        profilePic: participant.imageUrl,
                        firstName: participant.firstName,
                        lastName: participant.lastName
                    });
                }
            }
            if (reviewers.length === 0)
                return '';
            else
                return reviewers;

        }
        return (
            this.state.loader || this.props.publishingPracticeLoader ? <LoadingComponent active={this.state.loader || this.props.publishingPracticeLoader} message="Validating Playbook" /> :

                <div className="publishPackLayout" style={{ width: this.props.componentDesignerDimension.width - 100 }}>

                    {requestReview()}

                    <Maybe when={this.state.isReviewPending}>
                        <Form name="inReviewForm" style={{ 'width': '100%' }}>

                            {summarySection()}
                            <Grid >
                                <Grid.Row className="bg-light-blue mar_lr_0">
                                    <Grid.Column width={16}>
                                        <Form.Field>
                                            <Button type="submit" id='submit' className="button-submit" floated='right' style={{ 'margin': '0 10px' }} onClick={this.approve}>Approve</Button>
                                            <Button type="button" id='button' className="button-cancel" floated='right' onClick={this.rejectClick}>Reject</Button>


                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Maybe>

                    <Maybe when={(!this.state.loader && (this.props.selectedPracticeLibrary.status === 2 && this.state.isAuthorizedToPublish) || (this.props.selectedPracticeLibrary.status === 0 && this.state.isAuthorizedToPublish && reviewer() === '' && this.state.errors.length === 0))}>
                        <Grid className="publishPackLayout">
                            <Grid.Row className="bg-light-blue mar_lr_0">
                                <Grid.Column width={16}>
                                    <Form name="publishForm" onSubmit={(data) => { this.publishPractice(data) }}>
                                        <Form.Field>
                                            {!this.state.loader && <Button type="submit" id='submit' floated='right' className="button-submit" disabled={this.state.errors2.lenght > 0 || this.state.errors2.length > 0} onMouseEnter={() => dispatch.app.setHelpContext("Publish Button")}>Publish</Button>}
                                        </Form.Field>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Maybe>


                    <Maybe when={this.props.selectedPracticeLibrary.status === 3 && this.state.isAuthorizedToPublish == true}>
                        <Form name="updatePracticeForm" onSubmit={(data) => { this.movePracticeToIndesign(data) }} style={{ 'width': '100%' }}>

                            <Grid className="publishPackLayout">
                                <Grid.Row className="rowStyle">
                                    <Grid.Column width={4}>
                                        <strong>Review</strong>
                                    </Grid.Column>
                                    <Grid.Column width={4} floated='right'>
                                        <Form.Field>
                                            <Button type="submit" id='submit' floated='right' className="mar_tb_10 bg-blue">Update {this.props.practiceLabelName}</Button>
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid >
                        </Form>
                    </Maybe>

                    <PracticeRejectionNotesModal openModal={this.state.openNotesModal} closeModal={this.closeNotesModal} reject={this.reject} addNote={this.addNote} notes={this.state.currentReview.notes} playBookName={this.props.selectedPracticeLibrary.name} />
                </div>
        )
    }
}

export default withRouter(PublishPack);
